import { Archetype } from "./Archetype";
import { MinMax } from "./Common";
import { ComboBoxOption } from "./Input";

export const TOURNAMENT_FORMATS = ["Standard", "L3", "L6", "F5", "Sealed", "Draft", "Title", "AllStarDraft", "JudgeTower", "Pauper"] as const;
export type TournamentFormat = typeof TOURNAMENT_FORMATS[number];
export type FormatRulesDictionary = Record<TournamentFormat, FormatRules>;

export const tournamentFormatOptions: ComboBoxOption<TournamentFormat>[] = TOURNAMENT_FORMATS.map(x => ({ label: x, value: x }));

export type CardRestriction = {
    serial: string,
    source: string,
    description: string,
    rule: Archetype
}

export type FormatRules = {
    name: string,
    rules: string[],
    allowed: {
        cards: string[],
        additionalCategories?: string[],
        opus?: number[],
        rarities?: string[]
    }
    banned: {
        cards: string[],
        categories?: string[],
        opus?: number[]
    },
    restrictions?: CardRestriction[],
    restricted?: {
        cards?: string[]
    },
    links?: FormatRulesLink[]
}

export type FormatRulesLink = {
    id: number,
    title: string,
    ignore: boolean,
    path: string
};

export const tournamentFormatCardLimitMap: Record<TournamentFormat, MinMax> = {
    AllStarDraft: { min: 500, max: 500 },
    Draft: { min: 40, max: -1 },
    Sealed: { min: 40, max: -1 },
    L3: { min: 50, max: 50 },
    L6: { min: 50, max: 50 },
    F5: { min: 50, max: 50 },
    Standard: { min: 50, max: 50 },
    Title: { min: 50, max: 50 },
    JudgeTower: { min: 100, max: 300 },
    Pauper: { min: 50, max: 50 }
}

export const TOURNAMENT_FORMAT_MAX_SERIAL_MAP: Readonly<Record<TournamentFormat, number | null>> = {
    AllStarDraft: 1,
    Draft: null,
    Sealed: null,
    L3: 3,
    L6: 3,
    Standard: 3,
    Title: 3,
    JudgeTower: 1,
    F5: 3,
    Pauper: 3
}